import {
  HTTP_GETFORECASTLIST4_FETCHING,
  HTTP_GETFORECASTLIST4_SUCCESS,
  HTTP_GETFORECASTLIST4_FAILED,
  HTTP_RESET_FORECASTLIST4,
  server,
} from "../../Constants";
import { httpClient } from "../../utils/HttpClient";

export const setStateGetForecastToFetching4 = () => ({
  type: HTTP_GETFORECASTLIST4_FETCHING,
});

export const setStateGetForecastToSuccess4 = (payload) => ({
  type: HTTP_GETFORECASTLIST4_SUCCESS,
  payload,
});

export const setStateGetForecastToFailed4 = (payload) => ({
  type: HTTP_GETFORECASTLIST4_FAILED,
});

export const clearForecast4 = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_FORECASTLIST4 });
  };
};
export const getForecast4 = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearcode,
  yearid
) => {
  return async (dispatch) => {
    dispatch(setStateGetForecastToFetching4());
    try {
      const result = await httpClient.get(
        `${server.GETFORECAST4_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearcode}/${yearid}`
      );

      dispatch(setStateGetForecastToSuccess4(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateGetForecastToFailed4());
      return Promise.reject(error.message);
    }
  };
};
